class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.flkty = null;
  }

  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector('[data-recommendations]');
    if (!recommendations) return;

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]');

        if (!html) return;

        const inner = html.innerHTML;
        if (!inner) return;

        this.classList.remove('hidden');
        recommendations.innerHTML = inner;

        this.initSlider();
      });
  }

  destroySlider() {
    if (this.flkty) {
      try {
        this.flkty.destroy();
      } catch (e) {}
      this.flkty = null;
    }
  }
initSlider() {
  const track = this.querySelector('.js-flickity-upsell');
  if (!track) return;

  const Flickity = window.Flickity;
  if (!Flickity) return;

  this.destroySlider();

  this.flkty = new Flickity(track, {
    cellAlign: 'left',
    contain: true,
    groupCells: 2,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    freeScroll: false,
    wrapAround: false,
    adaptiveHeight: false,
    dragThreshold: 8,
    percentPosition: true
  });

  this.bindArrows();

  requestAnimationFrame(() => {
    this.flkty.resize();
    this.updateArrowState();
  });
}

bindArrows() {
  const prev = this.querySelector('[data-ws-recos-prev]');
  const next = this.querySelector('[data-ws-recos-next]');

  this.wsPrevBtn = prev || null;
  this.wsNextBtn = next || null;

  if (this.wsPrevBtn) {
    this.wsPrevHandler = () => {
      if (!this.flkty) return;
      this.flkty.previous(true);
      this.updateArrowState();
    };
    this.wsPrevBtn.addEventListener('click', this.wsPrevHandler);
  }

  if (this.wsNextBtn) {
    this.wsNextHandler = () => {
      if (!this.flkty) return;
      this.flkty.next(true);
      this.updateArrowState();
    };
    this.wsNextBtn.addEventListener('click', this.wsNextHandler);
  }

  if (this.flkty) {
    this.wsSelectHandler = () => this.updateArrowState();
    this.flkty.on('select', this.wsSelectHandler);
  }
}

updateArrowState() {
  if (!this.flkty) return;

  const index = this.flkty.selectedIndex || 0;
  const last = (this.flkty.slides ? this.flkty.slides.length - 1 : 0);

  if (this.wsPrevBtn) this.wsPrevBtn.disabled = index <= 0;
  if (this.wsNextBtn) this.wsNextBtn.disabled = index >= last;
}

destroySlider() {
  if (this.wsPrevBtn && this.wsPrevHandler) {
    this.wsPrevBtn.removeEventListener('click', this.wsPrevHandler);
  }
  if (this.wsNextBtn && this.wsNextHandler) {
    this.wsNextBtn.removeEventListener('click', this.wsNextHandler);
  }

  this.wsPrevBtn = null;
  this.wsNextBtn = null;
  this.wsPrevHandler = null;
  this.wsNextHandler = null;

  if (this.flkty) {
    try {
      if (this.wsSelectHandler) this.flkty.off('select', this.wsSelectHandler);
      this.flkty.destroy();
    } catch (e) {}
    this.flkty = null;
    this.wsSelectHandler = null;
  }
}

}

customElements.define('cart-recommendations', CartRecommendations);
